import { createFileRoute } from "@tanstack/react-router";
import { Inbox } from "@/components/inbox/Inbox";
import { validateInboxSearch } from "./index";

export const Route = createFileRoute("/_app/t/$ref")({
  validateSearch: validateInboxSearch,
  component: ThreadRoute,
});

function ThreadRoute() {
  const { ref } = Route.useParams();
  // Links from agents and Discord say /t/12; the inbox says T-12. Both work.
  const normalized = /^\d+$/.test(ref) ? `T-${ref}` : ref.toUpperCase();
  return <Inbox search={Route.useSearch()} selectedRef={normalized} />;
}
